export default __webpack_public_path__ + "alberta-tracheostomy.3068f664711bbc101383.svg";